export default "__VITE_ASSET__B13HYOPI__"